import { MainBodyContentContainer } from "@sc/custom.styled";

export const QuizBodyContainer = MainBodyContentContainer.extend`
  overflow: auto;
  height: calc(100vh - 80px);
  margin-top: 0;
  padding: 0 10px;
  overflow: hidden;
`;
